import { createIcon } from './createIcon';

/** Open folder — the expanded counterpart to `FolderIcon`, same footprint. */
export const FolderOpenIcon = createIcon({
  name: 'FolderOpenIcon',
  viewBox: '3 3 19 17',
  size: 12,
  ratio: 14 / 12,
  color: 'var(--text-secondary)',
  children: (
    <path
      d="M5 19l2.757 -7.351a1 1 0 0 1 .936 -.649h12.307a1 1 0 0 1 .986 1.164l-.996 5.211a2 2 0 0 1 -1.986 1.625h-14.004a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});

export default FolderOpenIcon;
